import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import Button from "../button";
import ModalTemplate from "./template";

interface Props {}

const AskCreateTimeslots: React.FC<Props> = () => {
  const modals = useSelector((state: State) => state.modals);
  const dispatch = useDispatch();

  const hide = () => {
    dispatch(hideModal());
  };

  const createTimeslot = () => {
    modals.data.createTimeslots();
    hide();
  };

  return (
    <ModalTemplate title="آیا مطمئنید؟">
      <div className="mb-3">در شبانه روز تنها ۳ بار اجازه ذخیره تغییرات را دارید.</div>
      <div>تغییرات ذخیره شود؟</div>
      <div className="flex gap-x-2">
        <Button variant="outline" onClick={hide} className="flex-1">
          بستن
        </Button>
        <Button className="flex-1" onClick={createTimeslot}>
          ذخیره شود
        </Button>
      </div>
    </ModalTemplate>
  );
};

export default AskCreateTimeslots;
